import React from 'react';
import { ProductsList } from '../../components/ProductsList';
import { useProducts } from '../../contexts/ProductsContext';
import './ProductsPage.scss';

export const ProductsPage = () => {
  const { products, loading, error, getAuthenticatedImage, refreshProducts, currentPage, totalPages, goToPage } = useProducts();

  if (loading) {
    return (
      <div className="productsPage">
        <div className="loading">Loading products...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="productsPage">
        <div className="error">Error: {error}</div>
      </div>
    );
  }

  const handleProductUpdate = async (productId: number) => {
    await refreshProducts();
  };

  return (
    <div className="productsPage">
      <ProductsList 
        products={products} 
        onGetAuthenticatedImage={getAuthenticatedImage}
        onProductUpdate={handleProductUpdate}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={goToPage}
        loading={loading}
      />
    </div>
  );
};
